<!--
지역정보(캐시)를 사용하기위한  mixin
------------------------------------

-->

<script>
import {get_active_regions, get_region} from "../../../classes/region-factory";

    export default {
        methods: {
            get_region,
            get_active_regions,
        },
    }
</script>